import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleUpSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronTriangleUpSmall"><Path d="M12 7.33301L7 13.9997H17L12 7.33301Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleUpSmall;
